import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Routes } from 'layouts/Routes';
import ScheduleMeeting from 'components/scheduleMeeting';
import MeetNow from 'components/MeetNow';
import Settings from 'components/Settings';
import GetStarted from 'components/GetStarted';
import SignOut from 'components/SignOut';

const ProtectedRoutes = () => (
  <Router>
    <Switch>
      <Route exact path={Routes.ROOT}>
        <ScheduleMeeting />
      </Route>
      <Route path={Routes.MEET_NOW}>
        <MeetNow />
      </Route>
      <Route path={Routes.SCHEDULE}>
        <ScheduleMeeting />
      </Route>
      <Route path={Routes.SETTINGS}>
        <Settings />
      </Route>
      <Route path={Routes.GET_STARTED}>
        <GetStarted />
      </Route>
      <Route path={Routes.SIGN_OUT}>
        <SignOut />
      </Route>
    </Switch>
  </Router>
);

export default ProtectedRoutes;
